import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireRole }) {
    const { user, loading } = useAuth();

    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
                <div className="flex items-center gap-3 text-[#003366]">
                    <div className="h-3 w-3 rounded-full bg-[#0066D9] animate-pulse" />
                    <div className="h-3 w-3 rounded-full bg-[#0066D9] animate-pulse delay-100" />
                    <div className="h-3 w-3 rounded-full bg-[#0066D9] animate-pulse delay-200" />
                </div>
            </div>
        );
    }

    if (!user) return <Navigate to="/login" replace />;

    if (requireRole && user.role !== requireRole) {
        return <Navigate to="/" replace />;
    }

    return children;
}
